import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Facebook, Twitter, LinkedIn, Phone, Email, LocationOn } from "@mui/icons-material";
import { motion } from "framer-motion";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <Box className="footer-main">
        {/* LEFT: Brand Info */}
        <Box className="footer-brand">
          <Typography variant="h6" className="footer-title">
            RM INFRASTRUCTURES
          </Typography>
          <Typography className="footer-text">
            Building a stronger future with innovation and integrity.
          </Typography>
        </Box>

        {/* CENTER: Contact Info + Map */}
        <Box className="footer-contact">
          <Typography variant="subtitle1" className="contact-title">
            Our Contact Details
          </Typography>
          <Box className="contact-details">
            <Typography className="contact-item">
              <Phone className="contact-icon" /> +91 6360938274, +91 6362222724
            </Typography>
            <Typography className="contact-item">
              <Email className="contact-icon" /> rminfrastructures06@gmail.com
            </Typography>
            <Typography className="contact-item">
              <LocationOn className="contact-icon" />
              #212, Dee Enclave, BB Nagar, Koti Hosahalli,
              Sahakaranagar Post, Bengaluru - 560092.
            </Typography>
          </Box>

          <div className="map-container">
            <iframe
              title="RM Infra Location"
              src="https://www.google.com/maps?q=BB%20Nagar,%20Koti%20Hosahalli,%20Bengaluru,%20Karnataka%20560092&output=embed"
              loading="lazy"
              allowFullScreen
            ></iframe>
          </div>
        </Box>

        {/* RIGHT: Social Icons */}
        <Box className="footer-social">
          <Typography className="social-title">Follow Us</Typography>
          <Box>
            <IconButton className="social-icon"><Facebook /></IconButton>
            <IconButton className="social-icon"><Twitter /></IconButton>
            <IconButton className="social-icon"><LinkedIn /></IconButton>
          </Box>
        </Box>
      </Box>

      <Typography className="footer-bottom">
        © {new Date().getFullYear()} RM Infrastructures — All Rights Reserved.
      </Typography>
    </motion.footer>
  );
};

export default Footer;
